// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"900e94f5","744":"c438d6a1"}[chunkId] + ".chunk.js";
};